var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { stormSnowHailFields } from '@shared/qualification/stormSnowHailQualificationFields';
import EditableModelInfo from '@backoffice/components/claim/EditableModelInfo.vue';
const claim = namespace('claim');
let StormSnowHailDamageQualification = class StormSnowHailDamageQualification extends Vue {
    get context() {
        return this.modelFieldsContextGetter(this.$tc.bind(this), this.isEditingClaim);
    }
    get qualification() {
        var _a, _b;
        return (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.claim.stormSnowHailDamageQualification) !== null && _b !== void 0 ? _b : {};
    }
    get modelFields() {
        if (!this.context)
            return null;
        return stormSnowHailFields(this.qualification, this.context);
    }
    async onSubmit(update) {
        var _a;
        await this.updateDraftPayload({
            stormSnowHailDamageQualification: {
                ...update.payload,
                id: (_a = this.qualification.id) !== null && _a !== void 0 ? _a : null,
            },
        });
    }
};
__decorate([
    claim.State('info')
], StormSnowHailDamageQualification.prototype, "info", void 0);
__decorate([
    claim.State('isEditingClaim')
], StormSnowHailDamageQualification.prototype, "isEditingClaim", void 0);
__decorate([
    claim.Getter('modelFieldsContext')
], StormSnowHailDamageQualification.prototype, "modelFieldsContextGetter", void 0);
__decorate([
    claim.Action('updateDraftPayload')
], StormSnowHailDamageQualification.prototype, "updateDraftPayload", void 0);
StormSnowHailDamageQualification = __decorate([
    Component({ components: { EditableModelInfo } })
], StormSnowHailDamageQualification);
export default StormSnowHailDamageQualification;
